export class RestoreAzureEntraIdRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entities",
            "baseName": "entities",
            "type": "Array<AzureEntraIdRestoreEntity>",
            "format": ""
        },
        {
            "name": "excludedConsents",
            "baseName": "excludedConsents",
            "type": "Array<AzureEntraIdRestoreConsent>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureEntraIdRequest.attributeTypeMap;
    }
    constructor() {
    }
}
